import { render } from "./VerificacaoProdutos.vue?vue&type=template&id=4c731717&scoped=true"
import script from "./VerificacaoProdutos.vue?vue&type=script&lang=js"
export * from "./VerificacaoProdutos.vue?vue&type=script&lang=js"

import "./VerificacaoProdutos.vue?vue&type=style&index=0&id=4c731717&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src130918171/src/app-heineken/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c731717"]])

export default __exports__